import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogService, TranslationService } from '@sdbn/common';
import { TransportOption } from '../../transport-options.model';

@Component({
  selector: 'app-transport-option-editor-files',
  templateUrl: './transport-option-editor-files.component.html',
  styleUrls: ['./transport-option-editor-files.component.scss']
})
export class TransportOptionEditorFilesComponent implements OnInit {

  transportOption: TransportOption;

  @Input('transportOption') set setTransportOption(transportOption: TransportOption) {
    this.transportOption = transportOption;
  }

  @Output() changed = new EventEmitter();

  currentResourceId: string;

  constructor(
    public translationService: TranslationService,
    private dialogService: DialogService
  ) {
  }

  public ngOnInit() {
  }

  public handleUpadedResource(resourceId: string): void {
    this.transportOption.resources.push(resourceId);
    this.currentResourceId = resourceId;
  }

  public selectResource(resourceId: string): void {
    this.currentResourceId = resourceId;
  }

  public handleDeleteClicked(): void {
    console.log('ask for deletion');
    this.dialogService.showConfirm(
      'tmc-yard.service.admin.transport-option-administration.delete-image.confirm-dialog.title',
      'tmc-yard.service.admin.transport-option-administration.delete-image.confirm-dialog.message'
    ).afterClosed().subscribe(result => {
      if (result) {
        let index = this.transportOption.resources.indexOf(this.currentResourceId, 0);
        this.transportOption.resources.splice(index, 1);
        this.currentResourceId = null;
      }
    });
  }

}
